import { newArray } from '@angular/compiler/src/util';
import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FichaAnalisisCHVI } from 'src/app/modelos/FichaAnalisisCHV';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { VistaAnalisisInfI } from 'src/app/modelos/VistaAnalisisInf';
import { ApiService } from '../../servicios/api/api.service';
import { AnalisisService } from '../../servicios/analisis/analisis.service';
//jspdf html2canvas
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { ToastrService } from 'ngx-toastr';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { ResConsultaExcel } from 'src/app/modelos/ResConsulta';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
//xlsx utils : npm install xlsx
import { read, writeFileXLSX } from "xlsx";
import * as XLSX from 'xlsx';
import { RespuestaFichaAnalisisCHVdto } from 'src/app/modelos/fichasAnalisis/RespuestaFichaAnalisisCHVdto';
import { FichaAnalisisCHVdto } from 'src/app/modelos/fichasAnalisis/FichaAnalisisCHVdto';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-analisischv',
  templateUrl: './analisischv.component.html',
  styleUrls: ['./analisischv.component.css']
})
export class AnalisischvComponent implements OnDestroy,OnInit {

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteI = new PeriodoReporteI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  ListaEstadosFuentes : VistaAnalisisInfI[];
  PeriodoActivo : PeriodoReporteI = new PeriodoReporteI;
  PeriodosConsultar : PeriodoReporteI[];
  IdPeriodoConsulta : BigInteger;
  PeriodoFichaAnalisis : PeriodoReporteI;
  PeriodoActual : String;
  PeriodoCol1 : String;
  PeriodoCol2 : String;
  PeriodoCol4 : String;
  PeriodoCol5 : String;
  PeriodoFichaGeneral : String;
  TablaTipCred13SCTG : FichaAnalisisCHVdto[];//SCTG= saldo capital total general
  TablaTipCred1SCTG : FichaAnalisisCHVdto[];//SCTG= saldo capital total general
  TablaTipCred3SCTG : FichaAnalisisCHVdto[];//SCTG= saldo capital total general
  TablaTipCred13SVG : FichaAnalisisCHVdto[];//SVG= saldo vencido general
  TablaTipCred1SVG : FichaAnalisisCHVdto[];//SVG= saldo vencido general
  TablaTipCred3SVG : FichaAnalisisCHVdto[];//SVG= saldo vencido general
  TablaTipCred13NCG : FichaAnalisisCHVdto[];//NCG= Numero de creditos general
  TablaTipCred1NCG : FichaAnalisisCHVdto[];//NCG= Numero de creditos general
  TablaTipCred3NCG : FichaAnalisisCHVdto[];//NCG= Numero de creditos general
  TablaTipCred13DG : FichaAnalisisCHVdto[];//DG= Departamentos general
  fichaAnalisisGeneral: RespuestaFichaAnalisisCHVdto;

  FuenteFichaIndividual : fuenteI = new fuenteI;
  PeriodoFichaIndividual : String;
  EstadoInfomacionFuente : EstadoInfoChvI = new EstadoInfoChvI;
  NovedadFichaIndividual : String;
  TablaTipCred13SCTI : FichaAnalisisCHVdto[];//SCTG= saldo capital total individual
  TablaTipCred1SCTI : FichaAnalisisCHVdto[];//SCTG= saldo capital total individual
  TablaTipCred3SCTI : FichaAnalisisCHVdto[];//SCTG= saldo capital total individual
  TablaTipCred13SVI : FichaAnalisisCHVdto[];//SVG= saldo vencido individual
  TablaTipCred1SVI : FichaAnalisisCHVdto[];//SVG= saldo vencido individual
  TablaTipCred3SVI : FichaAnalisisCHVdto[];//SVG= saldo vencido individual
  TablaTipCred13NCI : FichaAnalisisCHVdto[];//NCG= Numero de creditos individual
  TablaTipCred1NCI : FichaAnalisisCHVdto[];//NCG= Numero de creditos individual
  TablaTipCred3NCI : FichaAnalisisCHVdto[];//NCG= Numero de creditos individual
  TablaTipCred13DI : FichaAnalisisCHVdto[];//DG= Departamentos individual
  fichaAnalisisIndividual: RespuestaFichaAnalisisCHVdto;

  CargueMasivo : ConsultaFuenteI = new ConsultaFuenteI;
  ResultadoConsulta : ResCargueExcel[];

  VercargueFuente : Boolean;
  AprobarcargueFuente : Boolean;
  BtnAprobar : Boolean;
  CertNoMovi : Boolean;
  CargueAprobado : Boolean;

  @ViewChild('OpenModalFichaGeneral') OpenModalFichaGeneral: ElementRef;
  @ViewChild('CloseModalFichaGeneral') CloseModalFichaGeneral: ElementRef;

  @ViewChild('OpenModalFichaIndividual') OpenModalFichaIndividual: ElementRef;
  @ViewChild('CloseModalFichaIndividual') CloseModalFichaIndividual: ElementRef;

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };

    this.VercargueFuente = false;

    this.AprobarcargueFuente = false;

    this.BtnAprobar = false;

    this.CertNoMovi = false;

    this.analisisService.consultarPeriodoActivoCHV().subscribe(PActivo=>{
      this.PeriodoActivo = PActivo;
      this.PeriodoSeleccionado = PActivo;

      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);

      this.IdPeriodoConsulta = PActivo.id;

      this.PeriodoActual = PActivo.anio + " - " + PActivo.consecutivoPeriodo;

      //this.CosultarListaEstados();

      this.analisisService.EstadosParaPeriodoChv(PActivo.id).subscribe(Lista=>{
        this.ListaEstadosFuentes = Lista;
        this.dtTrigger.next();
      });
    });
    this.api.listaPeriodosCalendario().subscribe(Lista1=>{
      this.PeriodosConsultar = Lista1;
    });
    this.analisisService.getListaAniosVigenciaChv().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  regresarAnalisis(){
    this.router.navigate(['analisis']);
  }

  CosultarListaEstados(){//IdPeriodo
    /*this.IdPeriodoConsulta = IdPeriodo;
    this.api.EstadosParaPeriodoChv(IdPeriodo).subscribe(Lista2=>{
      this.ListaEstadosFuentes = Lista2;
    });*/
    if(this.consucutivoConsulta==0 || this.anioConsulta == 0){
      console.log("Seleccione periodo completo");
    } else {
      //this.openmodalcargando.nativeElement.click();
      this.api.PeriodoPorConsecutivoAnio(this.consucutivoConsulta, this.anioConsulta).subscribe(resultado1=>{
        this.PeriodoSeleccionado = resultado1;

        this.api.EstadosParaPeriodoChv(resultado1.id).subscribe(Lista2=>{
          this.ListaEstadosFuentes = Lista2;
          this.reinicializarDataTable();
          this.closemodacargando.nativeElement.click();
        });
      });
    }
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  FichaGeneralAnalisis(){
    //this.openmodalcargando.nativeElement.click();
    this.PeriodoFichaAnalisis = this.PeriodoSeleccionado;
    this.PeriodoFichaGeneral = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
    if(this.PeriodoSeleccionado.consecutivoPeriodo == "1"){
      this.PeriodoCol1 = (Number(this.PeriodoSeleccionado.anio)-1) + " - 4";
      this.PeriodoCol2 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      this.PeriodoCol4 = (Number(this.PeriodoSeleccionado.anio)-1) + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      this.PeriodoCol5 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
    } else {
      this.PeriodoCol1 = this.PeriodoSeleccionado.anio + " - " + (Number(this.PeriodoSeleccionado.consecutivoPeriodo)-1);
      this.PeriodoCol2 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      this.PeriodoCol4 = (Number(this.PeriodoSeleccionado.anio)-1) + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      this.PeriodoCol5 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
    }
    this.analisisService.fichaAnalisisGeneralCHV(this.PeriodoSeleccionado.consecutivoPeriodo, this.PeriodoSeleccionado.anio).subscribe(resultado=>{
      //console.log(resultado);
      this.fichaAnalisisGeneral = resultado;
      this.TablaTipCred13SCTG= resultado.datosTablaSaldoTotal1;
      this.TablaTipCred1SCTG= resultado.datosTablaSaldoTotal2;
      this.TablaTipCred3SCTG= resultado.datosTablaSaldoTotal3;
      this.TablaTipCred13SVG= resultado.datosTablaSaldoVencido1;
      this.TablaTipCred1SVG= resultado.datosTablaSaldoVencido2;
      this.TablaTipCred3SVG= resultado.datosTablaSaldoVencido3;
      this.TablaTipCred13NCG= resultado.datosTablaNumeroCreditos1;
      this.TablaTipCred1NCG= resultado.datosTablaNumeroCreditos2;
      this.TablaTipCred3NCG= resultado.datosTablaNumeroCreditos3;
      this.TablaTipCred13DG= resultado.datosTablaDepartamentos;
      this.closemodacargando.nativeElement.click();
      this.OpenModalFichaGeneral.nativeElement.click();
    });
  }


  //Prueba generar PDF no se usa
  FichaGeneralPDF(){
    const doc = new jsPDF()
    doc.text("SALDO CAPITAL TOTAL - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoCapitalTotalTipoCred13' });
    doc.addPage();
    doc.text("SALDO CAPITAL TOTAL - Tipo de crédito 1", 15,13);
    autoTable(doc, { html: '#TablaSaldoCapitalTotalTipoCred1' });
    doc.addPage();
    doc.text("SALDO CAPITAL TOTAL - Tipo de crédito 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoCapitalTotalTipoCred3' });
    doc.addPage();
    doc.text("SALDO VENCIDO - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoVencidoTipoCred13' });
    doc.addPage();
    doc.text("SALDO VENCIDO - Tipo de crédito 1", 15,13);
    autoTable(doc, { html: '#TablaSaldoVencidoTipoCred1' });
    doc.addPage();
    doc.text("SALDO VENCIDO - Tipo de crédito 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoVencidoTipoCred3' });
    doc.addPage();
    doc.text("NUMERO CREDITOS - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaNumeroCreditosTipoCred13' });
    doc.addPage();
    doc.text("NUMERO CREDITOS - Tipo de crédito 1", 15,13);
    autoTable(doc, { html: '#TablaNumeroCreditosTipoCred1' });
    doc.addPage();
    doc.text("NUMERO CREDITOS - Tipo de crédito 3", 15,13);
    autoTable(doc, { html: '#TablaNumeroCreditosTipoCred3' });
    doc.addPage();
    doc.text("DEPARTAMENTOS - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaDeapartamentosTipoCred13' });
    doc.save('FICHA_GENERAL.pdf');
  }

  FichaIndividualAnalisis(IdFuente){
    this.VercargueFuente = false;
    this.AprobarcargueFuente = false;
    this.BtnAprobar = false;
    this.CertNoMovi = false;
    //this.openmodalcargando.nativeElement.click();
    this.api.getFuenteById(IdFuente).subscribe(Result11=>{
      this.FuenteFichaIndividual = Result11;
      this.PeriodoFichaIndividual = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      this.CargueMasivo.anio = this.PeriodoSeleccionado.anio;
      this.CargueMasivo.trimestre = this.PeriodoSeleccionado.consecutivoPeriodo;
      this.CargueMasivo.cod_entidad = Result11.codEnti;
      this.CargueMasivo.idFuente = Result11.id;
      if(this.PeriodoSeleccionado.consecutivoPeriodo == "1"){
        this.PeriodoCol1 = (Number(this.PeriodoSeleccionado.anio)-1) + " - 4";
        this.PeriodoCol2 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
        this.PeriodoCol4 = (Number(this.PeriodoSeleccionado.anio)-1) + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
        this.PeriodoCol5 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      } else {
        this.PeriodoCol1 = this.PeriodoSeleccionado.anio + " - " + (Number(this.PeriodoSeleccionado.consecutivoPeriodo)-1);
        this.PeriodoCol2 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
        this.PeriodoCol4 = (Number(this.PeriodoSeleccionado.anio)-1) + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
        this.PeriodoCol5 = this.PeriodoSeleccionado.anio + " - " + this.PeriodoSeleccionado.consecutivoPeriodo;
      }
      this.api.EstadoInfParaFuente(this.PeriodoSeleccionado.id, Result11.id).subscribe(Result13=>{
        //console.log(Result13);
        this.EstadoInfomacionFuente = Result13;
        this.NovedadFichaIndividual = Result13.novedadSis.split("-",1) + "/ " + Result13.novedadUsu;
        if(Result13.novedadUsu.split(".",1)[0]=="14"){
          this.CertNoMovi = true;
        }
        if(Result13.observacionSis != null){
          this.BtnAprobar = true;
        }
        this.analisisService.fichaAnalisisIndividualCHV(this.PeriodoSeleccionado.consecutivoPeriodo, this.PeriodoSeleccionado.anio,this.FuenteFichaIndividual.id).subscribe(resultado=>{
          //console.log(resultado);
          this.fichaAnalisisIndividual = resultado;
          this.TablaTipCred13SCTI= resultado.datosTablaSaldoTotal1;
          this.TablaTipCred1SCTI= resultado.datosTablaSaldoTotal2;
          this.TablaTipCred3SCTI= resultado.datosTablaSaldoTotal3;
          this.TablaTipCred13SVI= resultado.datosTablaSaldoVencido1;
          this.TablaTipCred1SVI= resultado.datosTablaSaldoVencido2;
          this.TablaTipCred3SVI= resultado.datosTablaSaldoVencido3;
          this.TablaTipCred13NCI= resultado.datosTablaNumeroCreditos1;
          this.TablaTipCred1NCI= resultado.datosTablaNumeroCreditos2;
          this.TablaTipCred3NCI= resultado.datosTablaNumeroCreditos3;
          this.TablaTipCred13DI= resultado.datosTablaDepartamentos;
          this.closemodacargando.nativeElement.click();
          this.OpenModalFichaIndividual.nativeElement.click();
        });
      });
    });
  }


  VerCargue(){
    if(this.VercargueFuente){
      this.VercargueFuente = false;
    } else {
      this.VercargueFuente = true;
      if(this.AprobarcargueFuente){
        this.AprobarcargueFuente = false;
      }
      this.consultarHistorico();
    }
  }

  consultarHistorico(){
    this.api.consultarHistoricoCHV(this.CargueMasivo).subscribe(Result23 =>{
      this.ResultadoConsulta = Result23;
      if(Result23.length == 0 || Result23 == null){
        this.toastr.error('Existe un problema con la información en requerida.', 'Error!');
      }
    });
  }

  Descargar(){
    let dto: Array<ResConsultaExcel> = new Array<ResConsultaExcel>();
    for (let i of this.ResultadoConsulta){
      let dat: ResConsultaExcel = new ResConsultaExcel();
      dat.anio = i.anio;
      dat.trimestre = i.trimestre;
      dat.tipo_de_credito = i.tipo_de_credito;
      dat.departamento = i.departamento;
      dat.municipio = i.municipio;
      dat.solucion_vivienda = i.solucion_vivienda;
      dat.tenedor = i.tenedor;
      dat.moneda = i.moneda;
      dat.rango_vivienda = i.rango_vivienda;
      dat.mora = i.mora;
      dat.numero_creditos = i.numero_creditos;
      dat.saldo_capital_total = i.saldo_capital_total;
      dat.capital_una_mas_cuotas_vencidad = i.capital_una_mas_cuotas_vencidad;
      dat.tasa = i.tasa;
      dto.push(dat);
    }
    this.appService.downloadResConsulta(dto, 'Cargue '+this.PeriodoFichaIndividual+' '+this.FuenteFichaIndividual.codEnti);
  }

  //Funcion descargar pdf no se usa
  FichaIndividualPDF(){
    const doc = new jsPDF()
    doc.text("SALDO CAPITAL TOTAL - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoCapitalTotalTipoCred13-fichaind' });
    doc.addPage();
    doc.text("SALDO CAPITAL TOTAL - Tipo de crédito 1", 15,13);
    autoTable(doc, { html: '#TablaSaldoCapitalTotalTipoCred1-fichaind' });
    doc.addPage();
    doc.text("SALDO CAPITAL TOTAL - Tipo de crédito 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoCapitalTotalTipoCred3-fichaind' });
    doc.addPage();
    doc.text("SALDO VENCIDO - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoVencidoTipoCred13-fichaind' });
    doc.addPage();
    doc.text("SALDO VENCIDO - Tipo de crédito 1", 15,13);
    autoTable(doc, { html: '#TablaSaldoVencidoTipoCred1-fichaind' });
    doc.addPage();
    doc.text("SALDO VENCIDO - Tipo de crédito 3", 15,13);
    autoTable(doc, { html: '#TablaSaldoVencidoTipoCred3-fichaind' });
    doc.addPage();
    doc.text("NUMERO CREDITOS - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaNumCredTipoCred13-fichaind' });
    doc.addPage();
    doc.text("NUMERO CREDITOS - Tipo de crédito 1", 15,13);
    autoTable(doc, { html: '#TablaNumCredTipoCred1-fichaind' });
    doc.addPage();
    doc.text("NUMERO CREDITOS - Tipo de crédito 3", 15,13);
    autoTable(doc, { html: '#TablaNumCredTipoCred3-fichaind' });
    doc.addPage();
    doc.text("DEPARTAMENTOS - Tipo de crédito 1 y 3", 15,13);
    autoTable(doc, { html: '#TablaDeptosTipoCred13-fichaind' });
    doc.save('FICHA_ANALISIS_'+this.PeriodoFichaIndividual+'_'+this.FuenteFichaIndividual.codEnti+'.pdf');
  }

  AprobarCargue(){
    if(this.AprobarcargueFuente){
      this.AprobarcargueFuente = false;
    } else {
      this.AprobarcargueFuente = true;
      if(this.VercargueFuente){
        this.VercargueFuente = false;
      }
    }
  }

  GuardarAprobacion(){
    this.BtnAprobar = true;
    this.EstadoInfomacionFuente.estado = "Aprobado";
    this.EstadoInfomacionFuente.novedadSis = "99 - Rinde / Novedad reportada";
    if(this.EstadoInfomacionFuente.observacionSis==null){
      this.toastr.warning('Observación obligatoria.', 'Advertencia!');
      this.BtnAprobar = false;
    } else if(this.EstadoInfomacionFuente.observacionSis.length<=1){
      this.toastr.warning('Observación demasiado corta.', 'Advertencia!');
      this.BtnAprobar = false;
    } else {
      //console.log(this.EstadoInfomacionFuente);
      this.api.CambiarEstadoInformacionChv(this.EstadoInfomacionFuente, localStorage.getItem('usuario')).subscribe(Result24=>{
        if(Result24){
          this.toastr.success('Cargue aprobado.', 'OK!');
          this.CloseModalFichaIndividual.nativeElement.click();
          this.CosultarListaEstados();//this.IdPeriodoConsulta
        }
      }, error=>{
        this.toastr.error('No se guardó.', 'Error!');
        this.BtnAprobar = false;
      });
    }
  }



  //Descargar ficha de analisis General .XLSX
  exportarExcelv2() {
    /* creamos el nuevo workbook */
    var workbook = XLSX.utils.book_new();
    /* convertimos tabla 'tablaOriginal' a un  worksheet llamado "Flota Sana" */
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoCapitalTotalTipoCred13'));
    XLSX.utils.book_append_sheet(workbook, ws1, "SCT TC 1 y 3");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws2 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoCapitalTotalTipoCred1'));
    XLSX.utils.book_append_sheet(workbook, ws2, "SCT TC 1");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws3 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoCapitalTotalTipoCred3'));
    XLSX.utils.book_append_sheet(workbook, ws3, "SCT TC 3");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws4 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoVencidoTipoCred13'));
    XLSX.utils.book_append_sheet(workbook, ws4, "SV TC 1 y 3");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws5 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoVencidoTipoCred1'));
    XLSX.utils.book_append_sheet(workbook, ws5, "SV TC 1");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws6 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoVencidoTipoCred3'));
    XLSX.utils.book_append_sheet(workbook, ws6, "SV TC 3");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws7 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumeroCreditosTipoCred13'));
    XLSX.utils.book_append_sheet(workbook, ws7, "NC TC 1 y 3");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws8 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumeroCreditosTipoCred1'));
    XLSX.utils.book_append_sheet(workbook, ws8, "NC TC 1");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws9 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumeroCreditosTipoCred3'));
    XLSX.utils.book_append_sheet(workbook, ws9, "NC TC 3");
    /* convertimos tabla 'tablaFlSaC' a un  worksheet llamado "Tipo de Contrato" */
    var ws10 = XLSX.utils.table_to_sheet(document.getElementById('TablaDeapartamentosTipoCred13'));
    XLSX.utils.book_append_sheet(workbook, ws10, "DEPTOS TC 1 y 3");
    /* exportamos en el libro con los worksheets */
    XLSX.writeFile(workbook, "FichaAnalisisGeneral.xlsx");
  }

  ExportarExcelFichaAnalisisIndividual() {
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoCapitalTotalTipoCred13-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws1, "SCT TC 1 y 3");
    var ws2 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoCapitalTotalTipoCred1-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws2, "SCT TC 1");
    var ws3 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoCapitalTotalTipoCred3-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws3, "SCT TC 3");
    var ws4 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoVencidoTipoCred13-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws4, "SV TC 1 y 3");
    var ws5 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoVencidoTipoCred1-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws5, "SV TC 1");
    var ws6 = XLSX.utils.table_to_sheet(document.getElementById('TablaSaldoVencidoTipoCred3-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws6, "SV TC 3");
    var ws7 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumCredTipoCred13-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws7, "NC TC 1 y 3");
    var ws8 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumCredTipoCred1-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws8, "NC TC 1");
    var ws9 = XLSX.utils.table_to_sheet(document.getElementById('TablaNumCredTipoCred3-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws9, "NC TC 3");
    var ws10 = XLSX.utils.table_to_sheet(document.getElementById('TablaDeptosTipoCred13-fichaind'));
    XLSX.utils.book_append_sheet(workbook, ws10, "DEPTOS TC 1 y 3");
    XLSX.writeFile(workbook, "FichaAnalisis"+this.FuenteFichaIndividual.nombEntidad+".xlsx");
  }
}
